module.exports = "/images/sales-associate.png?920057f8b8a78121f272ad9c08e00e89";